
import { defineComponent, onBeforeMount, onBeforeUnmount, onMounted, onUnmounted, ref, watch } from '@vue/composition-api';
//import { useElementVisibility, useTemplateRefsList } from '@vueuse/core';
import { BannerType, RowType } from '~/types/solepro/PageBuilder';
import { elementIsInViewport } from "~/utils/helpers/functions";

/**
 * @TODO manage fallbackSrc
 */
export default defineComponent({
  setup(props) {
    const { node } = props as Readonly<{ node: BannerType | RowType }>;
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const content = node['bannerDatas'] ?? node;
    const videoTarget = ref(null);
    const hasIframe = content.videoSrc && !content.videoSrc.endsWith('.mp4');
    const playVideo = ref(content.videoSrc);
    let initialized = false;
    const videoIsInViewport = ref(false)

    const isInViewport = () => {
      const element = videoTarget.value;
      if (!element || !element.getBoundingClientRect) return;
      videoIsInViewport.value = elementIsInViewport(element)
      if (!initialized && content.videoSrc && content.videoPlayOnlyVisible == 'true' && !!videoIsInViewport.value) {
        playVideo.value = (`${content.videoSrc.replace(/autoplay=[01]/g, '')}?autoplay=1&mute=1&controls=0`).replace('??', '?'); /** @TODO do better */
        initialized = true;
        window.removeEventListener('scroll', isInViewport);
      }
    }


    onBeforeMount(() => {
      window.addEventListener('scroll', isInViewport);
    })
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', isInViewport);
    })
    onMounted(()=>{
      isInViewport();
    })

    return {
      playVideo,
      hasIframe,
      videoTarget
    };
  },
});
